import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { christmasContent, christmasImage } from '../christmas';
import { Snowfall, Garland, Ornament, StarDivider } from './ChristmasDecor';

const ChristmasHighlight = () => {
  const { lang } = useLanguage();
  const c = christmasContent[lang];
  return (
    <section id="navidad" className="relative overflow-hidden bg-[#0f0d09]" data-testid="home-christmas-section">
      <Garland />
      <Snowfall />
      <Ornament className="right-[4%] top-10 hidden lg:flex" color="#b3262e" size={40} line={60} />
      <div className="relative max-w-6xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative max-w-md mx-auto">
            <div className="absolute -top-4 -left-4 w-20 h-20 border-t border-l border-[#e6b83f]/60" />
            <div className="absolute -bottom-4 -right-4 w-20 h-20 border-b border-r border-[#e6b83f]/60" />
            <img src={christmasImage} alt="LAJO Navidad" className="w-full h-auto block" data-testid="home-christmas-image" />
          </div>
        </Reveal>
        <Reveal delay={120}>
          <span className="font-sans-el text-[12px] tracking-[0.35em] uppercase text-[#e6b83f]">{c.eyebrow}</span>
          <h2 className="font-deco text-3xl sm:text-4xl text-[#f7f1e3] mt-3">{c.homeTitle}</h2>
          <StarDivider />
          <p className="font-serif-el text-lg text-[#c9c2b3] leading-relaxed">{c.homeText}</p>
          <ul className="grid sm:grid-cols-2 gap-3 mt-6">
            {c.homePoints.map((p) => (
              <li key={p} className="flex items-center gap-2 font-sans-el text-[15px] text-[#e8e2d4]">
                <Check size={16} className="text-[#e6b83f] shrink-0" /> {p}
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-4 mt-8">
            <Link to="/navidad" data-testid="home-christmas-see-btn" className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-sm text-[13px] tracking-[0.2em] uppercase font-medium">
              {c.seeMore} <ArrowRight size={16} />
            </Link>
            <a href="#contact" data-testid="home-christmas-book-btn" className="btn-ghost-gold px-7 py-3.5 rounded-sm text-[13px] tracking-[0.2em] uppercase">{c.cta}</a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ChristmasHighlight;
